import { CServiceLogon } from "@/model/data/logAnalysis/CServiceLogon";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetCServiceLogonResData extends ApiGenericResponse {
    cserviceLogon: CServiceLogon[];

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.CServiceLogon) {
            this.cserviceLogon = new Array<CServiceLogon>();
            obj.CServiceLogon.forEach((element) => {
                let csl = new CServiceLogon();
                csl.parse(element);
                this.cserviceLogon.push(csl);
            });
        }
    }
}
